function labeledNumber(text, labels) {
  const numberFirstFormat = /^\s*[-+(]?\d/.test(text);
  for (const label of labels) {
    const before = text.match(new RegExp(`([+-]?\\d+(?:\\.\\d+)?)\\s*${label}`, 'i'));
    const after = text.match(new RegExp(`${label}\\s*[:=]?\\s*([+-]?\\d+(?:\\.\\d+)?)`, 'i'));
    if (numberFirstFormat && before) return Number(before[1]);
    if (!numberFirstFormat && after) return Number(after[1]);
    if (before) return Number(before[1]);
    if (after) return Number(after[1]);
  }
  return null;
}

function validReading(value, min, max) {
  if (value == null || value === '') return false;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue >= min && numericValue <= max;
}

function parseAnalyzerData(raw, profile) {
  const text = Array.from(String(raw || ''))
    .map(char => char.charCodeAt(0) < 32 && char !== '\r' && char !== '\n' && char !== '\t' ? ' ' : char)
    .join('').trim();
  let liter = labeledNumber(text, ['LITER', 'LITRE', 'LTR', 'LT']);
  let fat = labeledNumber(text, ['FAT']);
  let snf = labeledNumber(text, ['SNF']);
  let density = labeledNumber(text, ['DENSITY', 'DEN', 'CLR']);

  if (profile === 'ecomilk' && (!validReading(fat, 1, 15) || !validReading(snf, 1, 15))) {
    // EcoMilk sends the result inside parentheses. The legacy desktop code
    // splits that payload into two-character groups:
    //   06 50 09 00 ... => FAT 06.50, SNF 09.00
    const packet = text.match(/\(([^)]{8,})\)/)?.[1] || '';
    const digits = packet.replace(/\D/g, '');
    if (digits.length >= 8) {
      fat = Number(`${digits.slice(0, 2)}.${digits.slice(2, 4)}`);
      snf = Number(`${digits.slice(4, 6)}.${digits.slice(6, 8)}`);
      if (digits.length >= 12) {
        density = Number(`${digits.slice(8, 10)}.${digits.slice(10, 12)}`);
      }
    }
  }

  if (profile === 'lacto' && (!validReading(fat, 1, 15) || !validReading(snf, 1, 15))) {
    const values = text.match(/[+-]?\d+(?:\.\d+)?/g)?.map(Number).filter(Number.isFinite) || [];
    if (values.length >= 2) {
      fat = values[0] > 15 && Number.isInteger(values[0]) ? values[0] / 100 : values[0];
      snf = values[1] > 15 && Number.isInteger(values[1]) ? values[1] / 100 : values[1];
      if (!validReading(density, 0, 100) && values.length >= 3) {
        density = values[2] > 100 && Number.isInteger(values[2]) ? values[2] / 100 : values[2];
      }
    }
  }

  return {
    liter: validReading(liter, 0.001, 9999) ? liter : null,
    fat: validReading(fat, 1, 15) ? fat : null,
    snf: validReading(snf, 1, 15) ? snf : null,
    density: validReading(density, 0, 100) ? density : null,
  };
}

function parseLiterData(raw) {
  const text = String(raw || '').replace(/\0/g, '').trim();
  if (text.length <= 9) return null;
  // The deployed weighing scale sends values such as "+0000002.8 Kg".
  // Older indicators send the same value with "Lt". Remove either complete
  // unit before applying the desktop application's direct decimal conversion.
  const output = text.split(/\s*(?:KG|LT)\b/i)[0].trim();
  const value = Number(output);
  return validReading(value, 0.001, 9999) ? value : null;
}

function extractLiterFrames(raw) {
  const text = String(raw || '').replace(/\0/g, ' ');
  const expression = /[+-]?\d+(?:\.\d+)?\s*(?:LITER|LITRE|LTR|LT|KG)/ig;
  const frames = [];
  let match;
  let lastIndex = 0;
  while ((match = expression.exec(text)) !== null) {
    frames.push(match[0]);
    lastIndex = expression.lastIndex;
  }
  return {
    frames,
    remainder:frames.length ? text.slice(lastIndex) : text,
  };
}

function buildScaleZeroBytes(command = 'z') {
  const value = String(command || '').trim();
  if (!value) throw new Error('Scale zero command is empty.');
  const normalizedHex = value.replace(/^0x/i, '');
  if (/^[0-9a-f]{2}$/i.test(normalizedHex)) {
    return Uint8Array.from([parseInt(normalizedHex, 16), 0x0D]);
  }
  return Uint8Array.from([...value].map(char => char.charCodeAt(0) & 0xFF).concat(0x0D));
}

module.exports = { parseAnalyzerData, parseLiterData, extractLiterFrames, validReading, buildScaleZeroBytes };
